import React, { Component } from 'react';
import { connect } from "react-redux";
import Swal from 'sweetalert2';
import {changeSetting} from "../../../../actions/actions";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class TimeoutSettings extends Component {

    constructor(props) {
        super(props);
        this.state={
            sendMessagePendingChat:this.props.chatprop.settings.send_message_pending_chat,
            customerSeePastMessage:this.props.chatprop.settings.customer_see_past_message,

        }

        this.changeSendMessagePendingChat=this.changeSendMessagePendingChat.bind(this);
        this.changeCustomerSeePastMessage=this.changeCustomerSeePastMessage.bind(this);
        this.saveChanges = this.saveChanges.bind(this);

    }


    saveChanges(){
        var sendMessagePendingChat=this.state.sendMessagePendingChat;
        var customerSeePastMessage=this.state.customerSeePastMessage;

        this.props.dispatch(changeSetting({send_message_pending_chat:sendMessagePendingChat,customer_see_past_message:customerSeePastMessage}));

    }

    componentWillUnmount() {
        Swal.close();
    }


    changeCustomerSeePastMessage(e){
        if(e.target.checked){
            var customerSeePastMessage=1;
        } else{
            var customerSeePastMessage=0;
        }
        this.setState({
            customerSeePastMessage:customerSeePastMessage
        });

    }
    changeSendMessagePendingChat(e){
        if(e.target.checked){
            var sendMessagePendingChat=1;
        } else{
            var sendMessagePendingChat=0;
        }
        this.setState({
            sendMessagePendingChat:sendMessagePendingChat
        });

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="hv-setting-item-container">
                    <div className="hv-setting-item">
                        <div className="chatSettingTimeoutContainer">
                            <div>Let customers send messages while on hold</div>
                        </div>
                        <div className="settings-switch">
                            <label className="switch">
                                <input
                                    checked={this.state.sendMessagePendingChat == 1 ? true : false}
                                    onChange={e => this.changeSendMessagePendingChat(e)}
                                    className="auto_assignment_change"
                                    type="checkbox"
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div className="hv-setting-item">
                        <div className="chatSettingTimeoutContainer">
                            <div>Customer can see past messages</div>
                        </div>
                        <div className="settings-switch">
                            <label className="switch">
                                <input
                                    checked={this.state.customerSeePastMessage == 1 ? true : false}
                                    onChange={e => this.changeCustomerSeePastMessage(e)}
                                    className="auto_assignment_change"
                                    type="checkbox"
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>

                </div>
                <div className="submit mt-4">
                    <button className="btn btn-primary btn-sm "
                            onClick={()=>this.saveChanges()}>
                        save changes
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

export default TimeoutSettings;
